import { MiscUtils, FeatureFlags, history } from 'services';
import { TicketPreference } from 'types';

const redirectMap = {
  create: (accountId: string, ticketId: string, environment: string) =>
    `https://${environment}my.rackspace.com/portal/rs/${accountId}/ticket/create`,
  details: (accountId: string, ticketId: string, environment: string) =>
    `https://${environment}my.rackspace.com/portal/rs/${accountId}/ticket/detail/${ticketId}`,
  list: (accountId: string, ticketId: string, environment: string) =>
    `https://${environment}my.rackspace.com/portal/rs/${accountId}/ticket/index`,
};

const TicketPreferencesUtils = {
  redirectIfOptedOut: async (
    redirectTo: 'create' | 'details' | 'list',
    ticketPreferncesDetails: TicketPreference,
    ticketId?: string,
  ) => {
    if (FeatureFlags.isActive('opt-in-opt-out')) {
      const {
        userPrefError,
        accountPrefError,
        accountOptIn,
        userOptIn,
        issuetrak,
      } = ticketPreferncesDetails;
      const isPathnameListOptin = () =>
        window.location.pathname.toLowerCase().indexOf('list/optin') !== -1;

      const isPathnameOptOut = () =>
        window.location.pathname.toLocaleLowerCase().indexOf('/optout') !== -1;

      /* Redirect to myRack if user-pref fails and user is non issue trak with account optin as false. */
      if (userPrefError && !accountPrefError && !issuetrak && !accountOptIn) {
        TicketPreferencesUtils.redirectMyrack(redirectTo, ticketId);
      } else if (
        accountPrefError ||
        (userPrefError && !issuetrak && accountOptIn)
      ) {
        /* If (account-pref call fails) or (user-pref fails and user is non issue trak with account optin as true), keep them in ctui */
        if (isPathnameListOptin() || isPathnameOptOut()) {
          history.push('/list');
        }
      } else {
        /* If both user-pref and  account-pref calls is success, then apply Opt-In or Opt-Out Logic */
        /* Check if user is issuetrak then return to CTUI */
        if (issuetrak) {
          if (isPathnameListOptin() || isPathnameOptOut()) {
            history.push('/list');
          }
        } else {
          /* If user is non issueTrak, check for preferences */
          if (userOptIn) {
            if (isPathnameListOptin()) {
              history.push('/list');
            }
          } else if (userOptIn === false) {
            if (isPathnameListOptin()) {
              history.push('/list/optin');
            } else {
              TicketPreferencesUtils.redirectMyrack(redirectTo, ticketId);
            }
          } else if (userOptIn === null) {
            if (accountOptIn) {
              if (isPathnameListOptin()) {
                history.push('/list');
              }
            } else {
              if (isPathnameListOptin()) {
                history.push('/list/optin');
              } else {
                TicketPreferencesUtils.redirectMyrack(redirectTo, ticketId);
              }
            }
          }
        }
      }
    }
  },

  redirectMyrack: (redirectTo: string, ticketId?: string) => {
    const accountId = window.PORTAL_DATA.tenants[0].split(':')[1];
    window.location.replace(
      redirectMap[redirectTo](
        accountId,
        ticketId || '',
        MiscUtils.isProduction ? '' : 'staging.',
      ),
    );
  },
};

export { TicketPreferencesUtils };
